import { Image } from 'react-native';

import LightImages from '../Light/Images';

const _images = {
  ...LightImages,
  ic_info_circle: Image.resolveAssetSource(
    require('./../../../Assets/Images/Icons/icInfoCircleWhite.png'),
  ),
  ic_sync: Image.resolveAssetSource(require('./../../../Assets/Images/Icons/icSyncWhite.png')),
};
const images = { ..._images };

export default images;
